<template>
  <div>
    <app-header>
      <template #title>
        <h1 class="d-inline me-4">{{ loaded ? budget.name : 'Time & Materials Project' }}</h1>
        <span v-if="loaded && budget.status" class="status status-primary">{{ budget.status }}</span>
      </template>
    </app-header>

    <ul id="horizontal-nav" class="nav nav-horizontal">
      <router-link tag="li" class="nav-item" :to="{ name: 'budgets.overview' }">
        <a class="nav-link">Overview</a>
      </router-link>

      <router-link tag="li" class="nav-item" :to="{ name: 'budgets.billing' }">
        <a class="nav-link">Billing</a>
      </router-link>

      <router-link
        v-if="budget.quote && budget.quote.uuid"
        tag="li"
        class="nav-item"
        :to="{ name: 'budgets.panda' }"
      >
        <a class="nav-link">View Quote</a>
      </router-link>
    </ul>

    <router-view v-if="loaded"></router-view>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { helperMethods } from 'vx/modules/clients'

export default {
  data () {
    return {
      loaded: false
    }
  },

  computed: {
    ...mapState('budget', {
      budget: 'single'
    })
  },

  watch: {
    '$route.params.budget_id' () {
      this.loaded = false
      this.loadData()
    }
  },

  mounted () {
    this.$bus.$on('budget-reload-data', this.loadData)

    this.loadData()
  },

  beforeDestroy () {
    this.$bus.$off('budget-reload-data', this.loadData)
  },

  methods: {
    ...helperMethods,
    ...mapActions('budget', { getBudget: 'getSingle' }),

    loadData () {
      return this.getBudget(this.$route.params.budget_id).then(() => {
        return this.setClient(this.budget.client)
      }).then(() => {
        this.loaded = true
      })
    }
  }
}
</script>
